<script setup>
import {computed} from 'vue'
import {useRoute, useRouter} from "vue-router"
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String
})

// Dynamic View Store & Router
const viewStore = useViewStore(props.viewId)
const router = useRouter()
const route = useRoute()

// Computed Properties
const isFilterActive = computed(() => {
    return viewStore.isFilterActive
})

// Methods
const resetAllFilters = () => {
    viewStore.resetAllFilters()

    if (Object.keys(route.query).length) {
        router.push({query: null})
    }
}
</script>

<template>
    <button v-if="isFilterActive" class="btn btn-warning rounded-0" type="button" @click="resetAllFilters">
        <i class="bi bi-x"/>
    </button>
</template>